import React from "react";
import Modal from "./Modal";
import { connect } from "react-redux";
import { FaFlag } from "react-icons/fa";
import * as adReportActions from "../redux/actions/adReportActions";
import * as wallActions from "../redux/actions/wallActions";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import MiniLoader from "./MiniLoader";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import "./styles/ModalReportAd.css";

function ReportOption({ item, selected, onSelect }) {
  return (
    <label className={`report-ad-option${selected ? " is-selected" : ""}`}>
      <input
        type="radio"
        name="reason_id"
        value={item.key}
        checked={selected}
        onChange={() => onSelect(item.key)}
      />
      <span className="report-ad-option__marker" aria-hidden="true" />
      <span className="report-ad-option__label">{item.label}</span>
    </label>
  );
}

class ModalReportComment extends React.Component {
  state = {
    description: "",
    reasonId: "",
    submitting: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ description: "", reasonId: "", submitting: false });
      if (!this.props.adReportOptionsList.length) {
        this.fetchReportOptions();
      }
    }
  }

  fetchReportOptions = async () => {
    try {
      await this.props.LoadReportOption(this.props.user_id, this.props.token);
      if (this.props.optionsError) {
        alertify.warning(I18n.t(this.props.optionsError));
      }
    } catch (error) {
      console.log(error);
    }
  };

  onChangeDescription = (event) => {
    this.setState({ description: event.target.value });
  };

  onSelectReason = (reasonId) => {
    this.setState({ reasonId: String(reasonId) });
  };

  submitReport = async () => {
    const { comment, user_id, token } = this.props;
    if (!comment?.Id) return;

    if (!this.state.reasonId) {
      alertify.warning(I18n.t("ad_report_reason_required"));
      return;
    }

    this.setState({ submitting: true });

    try {
      const result = await this.props.ReportComment(token, {
        comment_id: comment.Id,
        reason_id: this.state.reasonId,
        message: this.state.description,
        id: user_id,
        lang: I18n.t("locale"),
      });

      if (!result?.success) {
        alertify.warning(I18n.t(result?.error || "try_later"));
        this.setState({ submitting: false });
        return;
      }

      alertify.success(I18n.t("saved_succesfull"));
      this.props.onClose();
    } catch (error) {
      console.log(error);
      this.setState({ submitting: false });
    }
  };

  render() {
    const { isOpen, onClose, adReportOptionsList, loadingOptions } = this.props;
    const { description, reasonId, submitting } = this.state;
    const isLoading = loadingOptions && !adReportOptionsList.length;

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={<Translate value="comment_report_title" />}
      >
        <div className="report-ad-modal">
          <div className="report-ad-modal-hero">
            <span className="report-ad-modal-icon" aria-hidden="true">
              <FaFlag />
            </span>
            <p className="report-ad-modal-title">
              <Translate value="ad_report_kind" />
            </p>
            <p className="report-ad-modal-hint">
              <Translate value="comment_report_hint" />
            </p>
          </div>

          {isLoading ? (
            <div className="report-ad-modal-loading">
              <MiniLoader />
            </div>
          ) : (
            <div
              className="report-ad-options"
              role="radiogroup"
              aria-label={I18n.t("ad_report_kind")}
            >
              {adReportOptionsList.map((item) => (
                <ReportOption
                  key={item.key}
                  item={item}
                  selected={String(reasonId) === String(item.key)}
                  onSelect={this.onSelectReason}
                />
              ))}
            </div>
          )}

          <div className="report-ad-field">
            <label className="report-ad-label" htmlFor="report_comment_text">
              <Translate value="comments" />
            </label>
            <textarea
              id="report_comment_text"
              className="report-ad-textarea"
              name="comment"
              rows={4}
              value={description}
              placeholder={I18n.t("ad_report_comment_placeholder")}
              onChange={this.onChangeDescription}
            />
          </div>

          <div className="report-ad-footer">
            <button
              type="button"
              className="report-ad-btn report-ad-btn--secondary"
              onClick={onClose}
              disabled={submitting}
            >
              <Translate value="close" />
            </button>
            <button
              type="button"
              className="report-ad-btn report-ad-btn--danger"
              disabled={isLoading || submitting || !adReportOptionsList.length}
              onClick={this.submitReport}
            >
              <Translate value="ad_report_button" />
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    adReportOptionsList: reducer.adReport.list,
    loadingOptions: reducer.adReport.loading,
    optionsError: reducer.adReport.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadReportOption: (user_id, token) =>
    dispatch(adReportActions.loadList({ user_id, token })),
  ReportComment: (token, params) =>
    dispatch(wallActions.reportComment({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalReportComment);
